var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "border-sm rounded-sm py-6" },
    [
      _c(_setup.BlockTitle, {
        staticClass: "mb-6 px-6",
        attrs: { title: "Видеоотзывы представителей клиник" },
      }),
      _vm._v(" "),
      _c(_setup.CoreSwiper, {
        attrs: {
          "slides-per-view": _setup.isMobile ? 1 : 2,
          "has-navigation": !_setup.isMobile,
        },
        scopedSlots: _vm._u([
          {
            key: "slides",
            fn: function ({ slideAttrs }) {
              return _vm._l(_vm.lpuVideoReviews, function (lpuReview) {
                return _c(
                  "div",
                  _vm._b({ key: lpuReview.id }, "div", slideAttrs, false),
                  [
                    _c(_setup.DoctorInfo, {
                      staticClass: "pb-6 px-6 doctor-info",
                      attrs: {
                        "img-src": lpuReview.avatar_large.url,
                        fio: `${lpuReview.firstname} ${lpuReview.surname}`,
                        workplace: lpuReview.position,
                        "lpu-review-id": lpuReview.id,
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "position-relative",
                        on: {
                          click: function ($event) {
                            return _setup.openVideoDialog(lpuReview.rutube_link)
                          },
                        },
                      },
                      [
                        _c("img", {
                          staticClass: "large-img",
                          class: {
                            "elevation-1": !_setup.isMobile,
                            "mx-auto": _setup.isMobile,
                          },
                          attrs: { alt: "/", src: lpuReview.video_preview.url },
                        }),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "video-button",
                            attrs: { type: "button" },
                          },
                          [
                            _c("span", { staticClass: "video-button-item" }, [
                              _c("span", {
                                staticClass:
                                  "ui-icon_reset primary--text ui-icon-player-play",
                              }),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              })
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }